import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class SocketPagosService extends Socket {

  constructor() {
    const urlSocket = GLOBAL.urlSocket

    super({ url: urlSocket, options: {} });
  }

}
